export var FETCH_PROJECT_REQUEST = 'FETCH_PROJECT_REQUEST';
export var FETCH_PROJECT_FAILED = 'FETCH_PROJECT_FAILED';
export var FETCH_PROJECT_SUCCEEDED = 'FETCH_PROJECT_SUCCEEDED';
export var UPDATE_PROJECT_REQUEST = 'UPDATE_PROJECT_REQUEST';
export var UPDATE_PROJECT_FAILED = 'UPDATE_PROJECT_FAILED';
export var UPDATE_PROJECT_SUCCEEDED = 'UPDATE_PROJECT_SUCCEEDED';
